// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00fa ot\u00e1zku";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
